/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TableRow } from '../models/TableRow';
import type { TableRowDto } from '../models/TableRowDto';
import type { UpdateTableRowsRequest } from '../models/UpdateTableRowsRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TableRowsService {

    /**
     * Retrieve all scores for the specified organization.
     * @param organizationId The ID of the organization to scope the table rows for.
     * @param tableModuleId The ID of the table module to scope the table rows for.
     * @param requestBody The request containing the rows to update.
     * @returns TableRow OK
     * @throws ApiError
     */
    public static updateTableRows(
        organizationId: string,
        tableModuleId: string,
        requestBody?: UpdateTableRowsRequest,
    ): CancelablePromise<Array<TableRow>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tablerows/{organizationId}/{tableModuleId}',
            path: {
                'organizationId': organizationId,
                'tableModuleId': tableModuleId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Retrieve all scores for the specified organization.
     * @param organizationId The ID of the organization to scope the table rows for.
     * @param tableModuleId The ID of the table module to scope the table rows for.
     * @returns TableRowDto OK
     * @throws ApiError
     */
    public static getTableRows(
        organizationId: string,
        tableModuleId: string,
    ): CancelablePromise<Array<TableRowDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tablerows/{organizationId}/{tableModuleId}',
            path: {
                'organizationId': organizationId,
                'tableModuleId': tableModuleId,
            },
        });
    }

}
